import type { AnswerKeyEntry } from '@ellie/shared';
import { BLOCK_META } from '@ellie/shared';

interface AnswerKeyProps {
  entries: AnswerKeyEntry[];
}

export function AnswerKey({ entries }: AnswerKeyProps) {
  // Filter out blocks with no meaningful answers (e.g. guided conversation)
  const withAnswers = entries.filter((e) => e.answers.length > 0);

  if (withAnswers.length === 0) return null;

  return (
    <div className="wb-page">
      <div className="wb-block-header">
        <span className="wb-block-tag wb-answer-key-tag">Answer Key</span>
        <h2 className="wb-block-title">Answer Key</h2>
        <p className="wb-block-subtitle">Check your answers here after completing the exercises</p>
      </div>

      <div className="wb-answer-key-blocks">
        {withAnswers.map((entry) => {
          const meta = BLOCK_META[entry.blockType];
          return (
            <div key={entry.blockId} className="wb-answer-key-block">
              <div className="wb-answer-key-block-header">
                <span className="wb-answer-key-emoji">{meta?.emoji}</span>
                <span className="wb-answer-key-block-title">{entry.blockTitle}</span>
              </div>
              <ol className="wb-answer-key-list">
                {entry.answers.map((answer, i) => (
                  <li key={i} className="wb-answer-key-item">
                    {answer}
                  </li>
                ))}
              </ol>
            </div>
          );
        })}
      </div>
    </div>
  );
}
